<template>
  <div>
    <v-card 
      class='mx-2' 
      outlined
    >
      <v-container>
        <v-row justify="center">
          <h4> Welcome Qumulex </h4>
        </v-row>
        <v-row justify="center">
          <h1>Finance &amp; Operations Team</h1>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" sm="6" md="4">
            <v-img 
              src="../assets/images/qx_link_desktop.png" 
              max-height="200px" 
              contain 
            />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-img 
              src="../assets/images/qx_station_2u.png" 
              max-height="200px" 
              contain 
            />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-img 
              src="../assets/images/qx_power_2u.png" 
              max-height="200px" 
              contain 
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "Home",
  props: ["id"],
  data: () => ({
    iddisp: ""
  }),
}
</script>